const CollapsedClass = "collapsed";
export function initializeAccountSummary() {
    let accountSummaryContainers = document.querySelectorAll('[data-account-summary]');

    [].forEach.call(accountSummaryContainers, (container) => initContainer(container));  
}

function initContainer(container: HTMLElement) {
    let trigger = container.querySelector('[data-account-summary-trigger]');

    trigger.addEventListener('click', () => {
        if (container.classList.contains(CollapsedClass)) {
            container.classList.remove(CollapsedClass);
        }
        else {
            container.classList.add(CollapsedClass);
        }
    })
}







